import { render, staticRenderFns } from "./OtherUserCenter.vue?vue&type=template&id=44e9b07a&scoped=true"
import script from "./OtherUserCenter.vue?vue&type=script&lang=js"
export * from "./OtherUserCenter.vue?vue&type=script&lang=js"
import style0 from "./OtherUserCenter.vue?vue&type=style&index=0&id=44e9b07a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e9b07a",
  null
  
)

export default component.exports